import { PartialLocationObject } from '../../server/types/bellaRequest';
import ShopApi from './shopApiAdapter';
import { Config } from 'Common/appshell_types';

type ApiServiceParamsType = {
    shopApiBaseUrl: string;
    config: Config;
    country: string;
    userAgent: string;
    location: PartialLocationObject;
    userIP?: string;
};

export const createApiService = ({
    shopApiBaseUrl,
    config,
    country,
    userAgent,
    location,
    userIP,
}: ApiServiceParamsType) => {
    const shopApi = new ShopApi({ apiBaseUrl: shopApiBaseUrl, config, country, userAgent, location, userIP });

    return {
        shopApi,
    };
};

export type ApiService = ReturnType<typeof createApiService>;

export default {
    createApiService,
};
